import P from "react";
import { clsx as j } from "../../../clsx/dist/clsx.js";
import { isNumber as a } from "../util/DataUtils.js";
import { filterProps as w } from "../util/ReactUtils.js";
function c(r) {
  "@babel/helpers - typeof";
  return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, c(r);
}
var S = ["x", "y", "top", "left", "width", "height", "className"];
function b() {
  return b = Object.assign ? Object.assign.bind() : function(r) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var e in n)
        Object.prototype.hasOwnProperty.call(n, e) && (r[e] = n[e]);
    }
    return r;
  }, b.apply(this, arguments);
}
function v(r, t) {
  var n = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(r);
    t && (e = e.filter(function(o) {
      return Object.getOwnPropertyDescriptor(r, o).enumerable;
    })), n.push.apply(n, e);
  }
  return n;
}
function x(r) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? v(Object(n), !0).forEach(function(e) {
      _(r, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(e) {
      Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return r;
}
function _(r, t, n) {
  return t = N(t), t in r ? Object.defineProperty(r, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = n, r;
}
function N(r) {
  var t = $(r, "string");
  return c(t) == "symbol" ? t : t + "";
}
function $(r, t) {
  if (c(r) != "object" || !r) return r;
  var n = r[Symbol.toPrimitive];
  if (n !== void 0) {
    var e = n.call(r, t);
    if (c(e) != "object") return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(r);
}
function E(r, t) {
  if (r == null) return {};
  var n = D(r, t), e, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(r);
    for (o = 0; o < i.length; o++)
      e = i[o], !(t.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(r, e) && (n[e] = r[e]);
  }
  return n;
}
function D(r, t) {
  if (r == null) return {};
  var n = {};
  for (var e in r)
    if (Object.prototype.hasOwnProperty.call(r, e)) {
      if (t.indexOf(e) >= 0) continue;
      n[e] = r[e];
    }
  return n;
}
var C = function(t, n, e, o, i, f) {
  return "M".concat(t, ",").concat(i, "v").concat(o, "M").concat(f, ",").concat(n, "h").concat(e);
}, L = function(t) {
  var n = t.x, e = n === void 0 ? 0 : n, o = t.y, i = o === void 0 ? 0 : o, f = t.top, p = f === void 0 ? 0 : f, m = t.left, u = m === void 0 ? 0 : m, y = t.width, l = y === void 0 ? 0 : y, h = t.height, s = h === void 0 ? 0 : h, g = t.className, O = E(t, S), d = x({
    x: e,
    y: i,
    top: p,
    left: u,
    width: l,
    height: s
  }, O);
  return !a(e) || !a(i) || !a(l) || !a(s) || !a(p) || !a(u) ? null : /* @__PURE__ */ P.createElement("path", b({}, w(d, !0), {
    className: j("recharts-cross", g),
    d: C(e, i, l, s, p, u)
  }));
};
export {
  L as Cross
};
